module.exports = __webpack_public_path__ + "media/images/socials/kaggle-a97bc5bb81e4a434d53e8c044874c775.png";